export default __webpack_public_path__ + "static/media/abcdropicon.d4bb2e39.png";